import HeadphonesIcon from '@mui/icons-material/Headphones';
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import apiCIP from '../services/apiCIP';
import api from '../services/api';

interface HablitarChatProps {
    userDados: {
        _id: string;
        instituicaoId?: string;
        dadosPessoais: {
            fotoURL?: string;
            nome?: string;
            email?: string;
            tel1?: string;
            tel2?: string;
            genero?: string;
            provincia?: string;
            municipio?: string;
            bairro?: string;
            numeroBI?: string;
            perfil?: string;
            rua?: string;
        }
        vinculoIsAdmin?: boolean;
        foto?: string;
    }
}

const HablitarChat: React.FC<HablitarChatProps> = ({ userDados }) => {
    const [aberto, setAberto] = useState(false);
    const [load, setLoad] = useState(false);
    const togglePanel = () => setAberto((prev) => !prev);

    const handleCadatrar = async () => {
        setLoad(true)
        try {
            const formData = new FormData();

            // if (userDados?.dadosPessoais?.fotoURL) {
            //     const response = await fetch(userDados?.dadosPessoais?.fotoURL ?? '');
            //     const blob = await response.blob();

            //     const file = new File(
            //         [blob],
            //         'foto.png',
            //         { type: blob.type }
            //     );

            //     formData.append('foto', file);
            // }

            formData.append('externalId', userDados?._id ?? '');
            formData.append('instituicaoId', '691c612c1eaa66082ea86165');
            formData.append('nome', userDados?.dadosPessoais?.nome ?? '');
            formData.append('email', userDados?.dadosPessoais?.email ?? '');
            formData.append('tel1', userDados?.dadosPessoais?.tel1 ?? '');
            formData.append('tel2', userDados?.dadosPessoais?.tel2 ?? '');
            formData.append('genero', userDados?.dadosPessoais?.genero ?? '');
            formData.append('provincia', userDados?.dadosPessoais?.provincia ?? '');
            formData.append('municipio', userDados?.dadosPessoais?.municipio ?? '');
            formData.append('bairro', userDados?.dadosPessoais?.bairro ?? '');
            formData.append('numeroBI', userDados?.dadosPessoais?.numeroBI ?? '');
            formData.append('perfil', 'User');


            const result = await apiCIP.post(
                '/admin/register-external',
                formData
            );

            // console.log(result?.data?.user?._id)

            // await api.patch(
            //     '/admin/edit',
            //     {
            //         cipId: result?.data?.user?._id ?? '',
            //         userId: userDados?._id ?? ''
            //     }
            // );

            console.log('Usuário cadastrado com sucesso:', result);
            togglePanel();

        } catch (error) {
            console.error('Erro ao cadastrar usuário:', error);
        }
        finally {
            setLoad(false)
        }
    };

    return (
        <>

            <Button
                variant="contained"
                onClick={togglePanel}
                aria-label={aberto ? "Fechar suporte" : "Abrir suporte"}
                aria-expanded={aberto}
                style={{ backgroundColor: 'transparent', width: '100%' }}
                sx={{
                    color: '#6e2068',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    borderRadius: '7px',
                    mx: 'auto',
                    my: 4,
                    px: 2,
                    py: 1.25,
                    '&:hover': { color: '#6e2068' },
                }}
            >
                {/* Adicionar Funcionalidades do Chat */}
                Habilitar Chat Institucional Público (CIP)
            </Button>

            <Dialog
                open={aberto}
                onClose={togglePanel}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                    },
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.25,
                        pb: 1,
                        borderBottom: '1px solid #f3f4f6',
                    }}
                >
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: '#f3f4f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <HeadphonesIcon sx={{color: '#D55B15', fontSize: 22}} />
                    </Box>

                    <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle1" fontWeight={600} color="#111827">
                            Chat Institucional Público (CIP)
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.25 }}>
                            <Box
                                sx={{
                                    width: 7, height: 7,
                                    borderRadius: '50%',
                                    background: '#16a34a',
                                    flexShrink: 0,
                                }}
                            />
                            <Typography variant="caption" color="text.secondary">
                                Ao clicar no botão, será criada uma conta para este utilizador, permitindo-lhe aceder e interagir no CIP através do chat da Armed.
                            </Typography>
                        </Box>
                    </Box>

                    {/* Botão fechar (X) */}
                    <IconButton
                        size="small"
                        onClick={togglePanel}
                        aria-label="Fechar"
                        sx={{ alignSelf: 'flex-start', color: '#6b7280' }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                {/* Corpo */}
                <DialogContent sx={{ pt: 2 }}>
                    {/* Coloca aqui o conteúdo do chat ou opções adicionais */}
                    <Typography variant="body2" color="text.secondary">

                    </Typography>
                </DialogContent>

                {/* Rodapé com acção */}
                <DialogActions sx={{ px: 2.5, pb: 2 }}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleCadatrar()}
                        sx={{
                            backgroundColor: '#D55B15',
                            borderRadius: '10px',
                            py: 1,
                            fontWeight: 500,
                            textTransform: 'none',
                            '&:hover': { backgroundColor: '#b84d12' },
                        }}
                    >
                        {load ? 'Aguarde..' : 'Continuar'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default HablitarChat;